<template>
  <WidgetCard title="Upcoming domain crawls" icon="clock-circle" :loading="loading" :error="error" :empty="emptyMessage">
    <template v-if="rows.length">
      <CrawlScheduleList :rows="rows" />
      <div v-if="hasOverdue" class="dw-note">
        "Due" means the scheduled time has passed and the crawl has not run yet.
      </div>
    </template>
  </WidgetCard>
</template>

<script>
  import WidgetCard from './WidgetCard.vue';
  import CrawlScheduleList from './CrawlScheduleList.vue';
  import DashboardService from '../../services/dashboard.service';
  import dashboardWidget from '../../mixins/dashboardWidget.mixin';

  export default {
    name: 'UpcomingDomainCrawlsWidget',
    components: { WidgetCard, CrawlScheduleList },
    // Account-wide — crawl schedules carry no tags or plan types.
    mixins: [dashboardWidget],
    data() {
      return {
        rows: []
      };
    },
    computed: {
      emptyMessage() {
        return !this.loading && !this.error && !this.rows.length ? 'No upcoming crawls' : '';
      },
      hasOverdue() {
        return this.rows.some((r) => r.overdue);
      }
    },
    methods: {
      fetchResource() {
        return DashboardService.fetchUpcomingDomainCrawls(10);
      },
      applyResult(rows) {
        this.rows = rows;
      }
    }
  };
</script>
